import { styled } from '@mui/material/styles';
import { Box, Button } from '@mui/material';

export const StyledDialog = {
  PaperProps: {
    sx: {
      height: '90vh',
    },
  },
};

export const OrderSummaryBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  backgroundColor: 'white',
  borderBottom: '1px solid',
  borderColor: theme.palette.grey[200],
}));

export const EmptyStateBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  paddingTop: theme.spacing(8),
  paddingBottom: theme.spacing(8),
}));

export const CloseButton = styled(Button)({
  //  Estilos adicionales si se necesitan
});

export const RemindersButton = styled(Button)({
  // Estilos adicionales si se necesitan
});
